<template>
    <div class="section">
        <div class="container">
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto" >
                    <h2 class="text-center">
                        Подключив мобильную торговлю AkiTorg вы получите.
                    </h2>
                </div>
            </div>
            <div class="md-layout-item md-layout md-gutter">
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">
                    <md-card class="md-card-custom1">
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="icon icon-primary popr2">
                                        <i class="far fa-clock"></i>
                                    </div>
                                </div>
                                <div class="md-layout-item">
                                    <h3 class="card-title">
                                        Увеличение скорости сбора заказов.
                                    </h3>
                                    <p class="card-description">
                                        Откажитесь от бумажных прайсов, ежедневных поездок и звонков на выписку. Вся актуальная инвормация есть в приложении для торгового представителя.
                                    </p>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
                <div class="md-layout-item md-medium-size-66 md-small-size-100  mx-auto">
                    <md-card class="md-card-custom1">
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="icon icon-success">
                                        <i class="fas fa-receipt"></i>
                                    </div>
                                </div>
                                <div class="md-layout-item">
                                    <h3 class="card-title">
                                        Соответствие ФЗ-54
                                    </h3>
                                    <p class="card-description popr">
                                        При получении наличных от клиента вы сможете пробить чек. К приложению "Мобильная торговля" возможно подключить кассу АТОЛ.
                                    </p>

                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">
                    <md-card class="md-card-custom1">
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="icon icon-info">
                                        <i class="fas fa-users"></i>
                                    </div>
                                </div>
                                <div class="md-layout-item">
                                    <h3 class="card-title">
                                        Контроль за сотрудниками
                                    </h3>
                                    <p class="card-description popr3">
                                          С помощью систем ГЛОНАС и GPS приложение собирает координаты создания документов, а так же умеет записывать трек передвижения сотрудников. Контролируйте бизнес через мобильное приложение.
                                    </p>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">
                    <md-card class="md-card-custom1">
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="icon icon-danger">
                                        <i class="fas fa-shopping-cart"></i>
                                    </div>
                                </div>
                                <div class="md-layout-item">
                                    <h3 class="card-title">
                                        Приложение для клиентов
                                    </h3>
                                    <p class="card-description">
                                        Вы можете бесплатно выдать клиентам мобильное приложение с катологом вашей продукции. Созданные заказы получит торговый представитель, сможет их откорректировать и отправить в 1С.
                                    </p>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">
                    <md-card class="md-card-custom1">
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="icon icon-info">
                                        <i class="fas fa-piggy-bank"></i>
                                    </div>
                                </div>
                                <div class="md-layout-item">
                                    <h3 class="card-title">
                                        Сокращение затрат
                                    </h3>
                                    <p class="card-description">
                                       Установка нашего ПО поможет избавиться от ручного ввода заказов и разнесения ПКО.
                                        Сократит расходы на оргтехнику и расходники. Топливо на лишние поездки в офис. А сколько вы заработаете если торговые будут вовремя выходить на маршрут и посещать торговые точки?
                                    </p>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">
                    <md-card class="md-card-custom1">
                        <md-card-content>
                            <div class="md-layout">
                                <div class="md-layout-item">
                                    <div class="icon icon-success">
                                        <i class="fas fa-thumbs-up"></i>
                                    </div>
                                </div>
                                <div class="md-layout-item">
                                    <h3 class="card-title">
                                        Уменьшение ошибок
                                    </h3>
                                    <p class="card-description">
                                        Исключение лишней ручной работы оператора, актуальный прайс-лит, остатки, цены, информация по акциям и приоритетным позициям помогут торговым представителям избежать ошибок. Избавление от ошибок избавит вас от лишней работы с претензиями клиентов и повысит лояльность.
                                    </p>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { InfoAreas } from "@/components";
  import RotatingCard from "../cards/RotatingCard";
  import PricingCard from "../cards/PricingCard";

  export default {
    name: "Introduction",
    components: {
      // PricingCard
      // RotatingCard
      // InfoAreas
    },
    data() {
      return {
      };
    }
  };
</script>

<style lang="scss">
    @import 'src/assets/scss/material-kit/_variables.scss';
    .popr {
        margin-top: 58px;
    }
    .popr2 {
        margin-top: 13px;
    }
    .popr3 {
        margin-top: 13px;
    }
    @media screen and (max-width: 1280px) {
        .popr { margin-top: 0px; }
        .popr2 { margin-top: 0px; }
        .popr2 { margin-top: 0px; }
    }


    .md-card-custom1 {
        text-align: center;

    &:after{
         background-color: rgba(0, 0, 0, 0.7) !important;
     }

    h1{
    small{
        font-size: 18px;
        display: inline-flex;
        height: 0;

    &:first-child{
         position: relative;
         top: -17px;
         font-size: 26px;
     }
    }
    }

    .md-card-content {
        /*height: 450px;*/
        padding: 15px!important;
        margin: 0!important;
    }

    ul{
        list-style: none;
        padding: 0;
        max-width: 240px;
        margin: 10px auto;

    li{
        color: $gray-color;
        text-align: center;
        padding: 12px 0;
        border-bottom: 1px solid rgba($gray-color,.3);

    &:last-child{
         border: 0;
     }
    b{
        color: $black-color;
    }
    .md-icon ,
    i{
        top: -1px;
        position: relative;
    }
    }
    }

    &.md-card-background,
    &[class*="bg-"]{
    ul{
    li{
        color: $white-color;
        border-color: rgba($white-color,.3);

    b{
        color: $white-color;
        font-weight: 700;
    }
    }
    }
    [class*="text-"],
    .card-category{
        color: $white-color !important;
    }
    }

    .icon {
        padding: 10px 0 0;
    }

    .card-title {
        margin-top: 30px;
    }

    .icon i {
        font-size: 60px;
        /*border: 1px solid #e5e5e5;*/
        /*border-radius: 50%;*/
        width: 130px;
        line-height: 130px;
        height: 130px;
    }

    }
</style>
